exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header .header-search-wrapper {\n  margin: 10px auto 0 80px; }\n\n#header .brand-logo img {\n  height: 64px;\n  width: auto; }\n\n#header .left {\n  margin-left: 89px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: calc(100% - 270px); }\n\n#header ul.left li {\n  overflow: hidden; }\n\n#header ul.left a {\n  font-size: 1.4rem;\n  padding: 0 8px; }\n\n#header .brand-logo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n  padding: 10px 0;\n  background-color: #ffffff;\n  margin-top: 0px;\n  padding: 0px;\n  height: 64px;\n  width: 64px; }\n\n.beta-timer {\n  color: #f1cb8f; }\n\n@media screen and (max-width: 677px) {\n  .beta-timer {\n    display: none; } }\n\n.helpicon {\n  font-size: 50px;\n  margin-right: -3px;\n  margin-left: -3px;\n  color: #e09900; }\n\n.ir-owner {\n  margin-right: 0px !important;\n  margin-left: 0px !important; }\n\n.beta-timer {\n  margin-right: 15px; }\n\n.breadcrumbs {\n  margin-left: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/header/header.component.scss
// module id = ../../../../../src/app/components/header/header.component.scss
// module chunks = main